var React = require('react');

function RadioButtonIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"primary-stroke","d":"M7.6 1c3.7 0 6.6 3 6.6 6.6s-3 6.6-6.6 6.6c-3.7 0-6.6-3-6.6-6.6l0 0C1 4 4 1 7.6 1z","key":0}),React.createElement("circle",{"className":"secondary-fill","cx":"7.6","cy":"7.6","r":"3.6","key":1})]);
}

RadioButtonIcon.defaultProps = {"viewBox":"0 0 15.2 15.2","className":"icon radio-button"};

module.exports = RadioButtonIcon;

RadioButtonIcon.default = RadioButtonIcon;
